'use strict';
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/modules/es.symbol.async-iterator.js
// module id = 720
// module chunks = 13